import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import PageLoading from './components/PageLoading';

import { useAppContext } from './contexts/AppContext';
import { useAuthContext } from './contexts/AuthContext';

import DashboardPage from './dashboard/Dashboard';
import LoginPage from './login/Login';
import VerificationAccount from './verificationAccount/VerificationAccount';
import VerificationAccountWhatsapp from './verificationAccountWhatsapp/VerificationAccountWhatsapp';
import RestorePassword from './restorePassword/RestorePassword';
import { PoliticaPrivacidade } from './PoliticaPrivacidade';
import { ExclusaoDados } from './ExclusaoDados';
import { TermosUso } from './TermosUso';
import EstablishmentPage from './establishment-page/EstablishmentPage';
import BillingBlockedPage from './billing/BillingBlocked';
import BrandingHome from './establishment-page/BrandingHome';

export default function App() {
    const { user } = useAuthContext();
    const { loadingApp } = useAppContext();

    if (loadingApp) {
        return <PageLoading />;
    }

    return (
        <div className="h-screen flex flex-col">
            <main className="flex-grow">
                <Routes>
                    <Route path="/verification-whatsapp-account/:code/:uid" element={<VerificationAccountWhatsapp />} />
                    <Route path="/verification-account" element={<VerificationAccount />} />
                    <Route path="/restore-password" element={<RestorePassword />} />
                    <Route path="/politicaDePrivacidade" element={<PoliticaPrivacidade />} />
                    <Route path="/exclusaoDeDados" element={<ExclusaoDados />} />
                    <Route path="/termosDeUso" element={<TermosUso />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/page/:slug" element={<EstablishmentPage />} />
                    <Route path="/page/*" element={<Navigate to="/login" replace />} />
                    <Route path="/landing-page/*" element={<Navigate to="/login" replace />} />
                    <Route path="/landing-preview/*" element={<Navigate to="/login" replace />} />
                    <Route path="/home" element={<Navigate to="/login" replace />} />
                    <Route path="/billing-blocked" element={<BillingBlockedPage />} />

                    <Route
                        path="*"
                        element={
                            user?.uid ? (
                                <DashboardPage />
                            ) : <BrandingHome />
                        }
                    />
                </Routes>
            </main>
        </div>
    );
}
